import { useCallback } from 'preact/hooks';
import { addEnhancedAttributionMacro } from '../../macros';
import { useControls } from './useControls';

export function useClickthru(destination_url?: string) {
  const { clickThru } = useControls();

  return useCallback(() => {
    if (clickThru) {
      if (destination_url) {
        const url = addEnhancedAttributionMacro(destination_url);
        clickThru({ url, id: '', playerHandles: true });
      }
    }
  }, [clickThru, destination_url]);
}
